import React from 'react';
import { Select } from 'antd';
import { MultiList } from '@appbaseio/reactivesearch';
import { css } from '@emotion/css';

const selectStyles = css`
	margin: 20px 10px 0px !important;
	width: 280px !important;
	background: white;
	@media (max-width: 576px) {
		margin: 10px 0px !important;
		padding: 10px;
	}
`;

/*
	This component can be used inside ReactiveComponent to generate an UI for
	MultiDropdownList using Select Component of Ant Design.
*/

class SelectComponent extends React.Component {
	state = {
		selectedItems: [],
	};

	static getDerivedStateFromProps(props, state) {
		const { selectedItems } = state;
		const { selectedValue } = props;
		if (selectedValue && selectedValue.length !== selectedItems.length) {
			return {
				selectedItems: selectedValue,
			};
		}
		return null;
	}

	componentDidUpdate(prevProps) {
		const { selectedValue } = prevProps;
		const { selectedValue: newValues, setQuery, dataField } = this.props;

		if (newValues !== selectedValue) {
			const query = MultiList.defaultQuery(newValues, {
				queryFormat: 'or',
				dataField,
			});
			setQuery({
				query,
				value: newValues,
			});
		}
	}

	handleChange = selectedItems => {
		const { setQuery, dataField } = this.props;
		const query = MultiList.defaultQuery(selectedItems, {
			queryFormat: 'or',
			dataField,
		});
		setQuery({
			query,
			value: selectedItems,
		});
		this.setState({ selectedItems });
	};

	render() {
		const { selectedItems } = this.state;
		const { dataField, dataKey, selectComponentProps, aggregations } = this.props;
		let items = [];
		if (aggregations && aggregations[dataField] && aggregations[dataField].buckets.length) {
			/* eslint-disable camelcase */
			items = aggregations[dataField].buckets.map(({ key: itemKey, doc_count }) => {
				return {
					value: itemKey,
					count: doc_count,
				};
			});
			/* eslint-enable camelcase */
		}

		return (
			<Select
				className={selectStyles}
				key={dataKey}
				mode="multiple"
				placeholder="Select Authors"
				value={selectedItems}
				onChange={this.handleChange}
				style={{ width: '100%' }}
				{...selectComponentProps}
			>
				{items.map(item => (
					<Select.Option key={item.value} value={item.value}>
						{item.value || 'N/A'}
					</Select.Option>
				))}
			</Select>
		);
	}
}

export default SelectComponent;
